module.exports = __webpack_public_path__ + "img/default.dba7f984.png";